function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
import { extractFormData, parseHTMLSection } from "./CartUtils";
import CartAPI from "./CartAPI";
var SideCart = /*#__PURE__*/function (_HTMLElement) {
  function SideCart() {
    var _this;
    _classCallCheck(this, SideCart);
    _this = _callSuper(this, SideCart);
    _this.maincart = document.querySelector('main-cart');
    _this.cartAPI = CartAPI;
    _this.init();
    return _this;
  }
  _inherits(SideCart, _HTMLElement);
  return _createClass(SideCart, [{
    key: "init",
    value: function init() {
      this.setupEventListeners();
      console.info('SideCart initialized');
    }
  }, {
    key: "open",
    value: function open(triggeredBy) {
      var _this2 = this;
      document.body.classList.add('overflow-hidden');
      var pageOverlay = document.querySelector('.page-overlay-sidecart');
      setTimeout(function () {
        _this2.classList.add('open');
        pageOverlay === null || pageOverlay === void 0 || pageOverlay.classList.add('open');
      });
      console.info('SideCart opened triggered by:', triggeredBy);
    }
  }, {
    key: "close",
    value: function close(triggeredBy) {
      var _this3 = this;
      document.body.classList.remove('overflow-hidden');
      var pageOverlay = document.querySelector('.page-overlay-sidecart');
      setTimeout(function () {
        _this3.classList.remove('open');
        pageOverlay === null || pageOverlay === void 0 || pageOverlay.classList.remove('open');
      });
      console.info('SideCart closed triggered by:', triggeredBy);
    }
  }, {
    key: "setupEventListeners",
    value: function setupEventListeners() {
      this.initializeOpenEvent();
      this.initializeCloseEvent();
      this.initializeAddEvent();
      this.initializeRemoveEvent();
      this.initializeUpdateEvent();
      this.initializeUpdateVariantEvent();
    }
  }, {
    key: "initializeOpenEvent",
    value: function initializeOpenEvent() {
      var _this4 = this;
      var cartButton = document.querySelector('#side-cart-button');
      if (!cartButton) {
        console.error('The button/anchor with id #side-cart-button could not be found.');
      } else {
        cartButton.addEventListener('click', function (event) {
          event.preventDefault();
          if (typeof _this4.open === 'function') {
            _this4.open('button');
          } else {
            console.error('The open method does not exist on the <side-cart> element.');
          }
        });
      }
    }
  }, {
    key: "initializeCloseEvent",
    value: function initializeCloseEvent() {
      var _this5 = this;
      this.addEventListener('keyup', function (evt) {
        return evt.code === 'Escape' && _this5.close("escape");
      });
      var closeButton = this.querySelector('#side-cart-close');
      if (closeButton) {
        closeButton.addEventListener('click', function () {
          return _this5.close("inner-close-button");
        });
      }
    }
  }, {
    key: "initializeAddEvent",
    value: function initializeAddEvent() {
      var _this6 = this;
      document.removeEventListener('click', this.handleAddToCart);
      this.handleAddToCart = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(evt) {
          var target, formData, _this6$maincart, result, sections, itemCount, _t;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.p = _context.n) {
              case 0:
                target = evt.target;
                if (!(target && target.classList.contains('add-to-cart'))) {
                  _context.n = 4;
                  break;
                }
                evt.stopPropagation();
                evt.preventDefault();
                console.info('Add to cart clicked');
                formData = extractFormData(target);
                if (!formData) {
                  _context.n = 4;
                  break;
                }
                _context.p = 1;
                _context.n = 2;
                return _this6.cartAPI.addToCart(formData);
              case 2:
                result = _context.v;
                console.info('Item added to cart:', result);
                sections = result['sections'];
                itemCount = result['item_count'];
                _this6.renderHTML(sections);
                (_this6$maincart = _this6.maincart) === null || _this6$maincart === void 0 || _this6$maincart.updateCart(itemCount);
                _context.n = 4;
                break;
              case 3:
                _context.p = 3;
                _t = _context.v;
                console.error('Failed to add item to cart:', _t);
              case 4:
                return _context.a(2);
            }
          }, _callee, null, [[1, 3]]);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }();
      document.addEventListener('click', this.handleAddToCart);
    }
  }, {
    key: "initializeRemoveEvent",
    value: function initializeRemoveEvent() {
      var _this7 = this;
      var buttons = this.querySelectorAll('.side-cart-item__remove');
      buttons.forEach(function (button) {
        button.addEventListener('click', /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(evt) {
            var item, formData, _this7$maincart, result, sections, itemCount, _t2;
            return _regenerator().w(function (_context2) {
              while (1) switch (_context2.p = _context2.n) {
                case 0:
                  evt.preventDefault();
                  console.info('Remove from cart clicked');
                  item = button.getAttribute('data-line-item');
                  formData = {
                    id: item,
                    quantity: 0,
                    sections: 'ajax-side-cart,ajax-cart-icon'
                  };
                  if (!formData) {
                    _context2.n = 4;
                    break;
                  }
                  _context2.p = 1;
                  _context2.n = 2;
                  return _this7.cartAPI.removeFromCart(formData);
                case 2:
                  result = _context2.v;
                  console.info('Item removed from cart:', result);
                  sections = result['sections'];
                  itemCount = result['item_count'];
                  _this7.renderHTML(sections);
                  (_this7$maincart = _this7.maincart) === null || _this7$maincart === void 0 || _this7$maincart.updateCart(itemCount);
                  _context2.n = 4;
                  break;
                case 3:
                  _context2.p = 3;
                  _t2 = _context2.v;
                  console.error('Failed to remove item from cart:', _t2);
                case 4:
                  return _context2.a(2);
              }
            }, _callee2, null, [[1, 3]]);
          }));
          return function (_x2) {
            return _ref2.apply(this, arguments);
          };
        }());
      });
    }
  }, {
    key: "initializeUpdateEvent",
    value: function initializeUpdateEvent() {
      var _this8 = this;
      var inputs = this.querySelectorAll('.side-cart-item__quantity-input');
      inputs.forEach(function (input) {
        var inputElement = input;
        inputElement.addEventListener('change', /*#__PURE__*/function () {
          var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(evt) {
            var item, formData, _this8$maincart, result, sections, itemCount, _t3;
            return _regenerator().w(function (_context3) {
              while (1) switch (_context3.p = _context3.n) {
                case 0:
                  evt.preventDefault();
                  console.info('Update cart item');
                  item = inputElement.getAttribute('data-line-item');
                  formData = {
                    id: item,
                    quantity: inputElement.value,
                    sections: 'ajax-side-cart,ajax-cart-icon'
                  };
                  if (!formData) {
                    _context3.n = 4;
                    break;
                  }
                  _context3.p = 1;
                  _context3.n = 2;
                  return _this8.cartAPI.updateItemCart(formData);
                case 2:
                  result = _context3.v;
                  console.info('Cart item updated:', result);
                  sections = result['sections'];
                  itemCount = result['item_count'];
                  _this8.renderHTML(sections);
                  (_this8$maincart = _this8.maincart) === null || _this8$maincart === void 0 || _this8$maincart.updateCart(itemCount);
                  _context3.n = 4;
                  break;
                case 3:
                  _context3.p = 3;
                  _t3 = _context3.v;
                  console.error('Failed to update cart item:', _t3);
                case 4:
                  return _context3.a(2);
              }
            }, _callee3, null, [[1, 3]]);
          }));
          return function (_x3) {
            return _ref3.apply(this, arguments);
          };
        }());
      });
    }
  }, {
    key: "initializeUpdateVariantEvent",
    value: function initializeUpdateVariantEvent() {
      var _this9 = this;
      var inputs = document.querySelectorAll('.cart__item__variant__input');
      inputs.forEach(function (input) {
        var inputElement = input;
        inputElement.addEventListener('change', /*#__PURE__*/function () {
          var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(evt) {
            var item, styleNumber, formDataToDelete, formDataNewItem, resultDelete, resultNew, sections, _t4;
            return _regenerator().w(function (_context4) {
              while (1) switch (_context4.p = _context4.n) {
                case 0:
                  evt.preventDefault();
                  console.info('Update cart item');
                  item = inputElement.getAttribute('data-line-item');
                  styleNumber = inputElement.getAttribute('data-style');
                  formDataToDelete = {
                    id: item,
                    quantity: 0,
                    sections: 'ajax-side-cart,ajax-cart-icon'
                  };
                  formDataNewItem = {
                    items: [{
                      id: Number(inputElement.value),
                      quantity: 1,
                      properties: {
                        "Style": styleNumber
                      }
                    }],
                    sections: 'ajax-side-cart,header'
                  };
                  if (!(formDataToDelete && formDataNewItem)) {
                    _context4.n = 5;
                    break;
                  }
                  _context4.p = 1;
                  _context4.n = 2;
                  return _this9.cartAPI.removeFromCart(formDataToDelete);
                case 2:
                  resultDelete = _context4.v;
                  console.info('Item removed from cart:', resultDelete);
                  _context4.n = 3;
                  return _this9.cartAPI.addToCart(formDataNewItem);
                case 3:
                  resultNew = _context4.v;
                  console.info('Item added to cart:', resultNew);
                  sections = resultNew['sections'];
                  _this9.renderHTML(sections);
                  _context4.n = 5;
                  break;
                case 4:
                  _context4.p = 4;
                  _t4 = _context4.v;
                  console.error('Failed to remove item from cart:', _t4);
                case 5:
                  return _context4.a(2);
              }
            }, _callee4, null, [[1, 4]]);
          }));
          return function (_x4) {
            return _ref4.apply(this, arguments);
          };
        }());
      });
    }
  }, {
    key: "renderHTML",
    value: function renderHTML(sections) {
      var HTMLSection = parseHTMLSection(sections['ajax-side-cart']);
      var sideCart = document.querySelector('side-cart');
      if (!sideCart) {
        console.error('No se encontró el elemento "side-cart".');
        return;
      }
      sideCart.innerHTML = '';
      sideCart === null || sideCart === void 0 || sideCart.appendChild(HTMLSection);
      this.initializeUpdateEvent();
      this.initializeUpdateVariantEvent();
      this.initializeRemoveEvent();
      this.initializeCloseEvent();
      this.initializeAddEvent();
      this.open("update");
      var newCartIcon = parseHTMLSection(sections['ajax-cart-icon']);
      var cartIcon = document.querySelector('#side-cart-button');
      if (!cartIcon) {
        console.error('No se encontró el elemento "cart-icon".');
        return;
      }
      cartIcon.innerHTML = '';
      cartIcon === null || cartIcon === void 0 || cartIcon.appendChild(newCartIcon);
      this.initializeOpenEvent();
      console.info('Cart updated.');
      return;
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
export default SideCart;